export default __webpack_public_path__ + "static/media/233.81971c9c.png";